import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-file-add",
  templateUrl: "./med-icon-file-add.component.html",
})
export class MedIconFileAddComponent extends SvgMixinComponent {}
